import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { IRessource } from '../models/ressource';
import { IRessourceCategory } from '../models/ressource-category';
import { RessourceCategoryService } from '../services/ressource-category.service';
import { RessourceService } from '../services/ressource.service';

@Component({
    selector: 'app-ressource',
    templateUrl: './ressource.component.html',
    styleUrls: ['./ressource.component.css'],
    standalone: false
})
export class RessourceComponent implements OnInit {

  constructor(
    private route : ActivatedRoute,
    private ressourceService : RessourceService,
    private ressourceCategoriesService : RessourceCategoryService
  ) { }

  ressources : IRessource[] = [];
  ressourceCategories : IRessourceCategory[] = [];

  public formGroup!: UntypedFormGroup;
  private editedRowIndex!: number;



  ngOnInit(): void {
    this.ressources = this.route.snapshot.data.ressources as IRessource[];
    this.ressourceCategoriesService.searchRessourceCategories({pageNumber: 0, pageSize: 999999})
    .subscribe(response => {
      this.ressourceCategories = response.data
    })
    
  }

  updateList(){
    this.ressourceService.searchRessources({pageNumber: 0, pageSize: 999999})
    .pipe(first())
    .subscribe(response => {
      this.ressources = response.data;
    })
  }

  addHandler({ sender }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(null, Validators.required),
      nameShort: new UntypedFormControl(null, Validators.required),
      ressourceCategory: new UntypedFormControl(null, Validators.required),
      isHidden: new UntypedFormControl(false, Validators.required),
    });

    sender.addRow(this.formGroup);
  }

  editHandler({ sender, rowIndex, dataItem }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(dataItem.name, Validators.required),
      nameShort: new UntypedFormControl(dataItem.nameShort, Validators.required),
      ressourceCategory: new UntypedFormControl(dataItem.ressourceCategory),
      isHidden: new UntypedFormControl(dataItem.isHidden, Validators.required),
    });

    this.editedRowIndex = rowIndex;

    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public saveHandler(event) {
    const request: any = {
      name: event.formGroup.value.name,
      nameShort: event.formGroup.value.nameShort,
      ressourceCategoryId: event.formGroup.value.ressourceCategory?.id,
      isHidden: event.formGroup.value.isHidden,
      id: event.dataItem.id ?? null,
    }
    if (!event.dataItem.id){
      this.ressourceService.createRessource(request)
      .subscribe(response => {
        this.updateList();
      });
    } else {
      this.ressourceService.updateRessource(request)
      .subscribe(response => {
        this.updateList();
      });;
    }

    event.sender.closeRow(event.rowIndex);
    
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  deletionDialogOpened = false;
  private itemToDelete: { id: string } | null = null;

  public removeHandler({ dataItem }) {
    this.itemToDelete = dataItem;
    this.deletionDialogOpened = true;
  }

  public deleteConfirmed() {
    const dataItem = this.itemToDelete;
    this.itemToDelete = null;
    if (!dataItem) return;
    this.ressourceService.deleteRessource(dataItem.id)
    .subscribe(response => {
      this.updateList();
    });;
  }


}
